import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box } from '@mui/material';
import { useCrumbsStyles } from './Crumbs.styles';

function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
  event.preventDefault();
}

interface ICrumbsProps {
  linksData: {
    link: string;
    name?: string | null;
    pageName: string;
    parentPageName: string;
  };
  darkTheme: boolean;
}

const CollapsedBreadcrumbs: React.FC<ICrumbsProps> = ({
  linksData,
  darkTheme,
}) => {
  const { classes, cx } = useCrumbsStyles();

  return (
    <Box
      role="presentation"
      onClick={handleClick}
      sx={{ mb: 3, color: '#fff' }}
    >
      <Breadcrumbs
        maxItems={4}
        aria-label="breadcrumb"
        separator={
          <ArrowForwardIcon
            fontSize="small"
            className={cx(classes.separator, darkTheme ? 'dark' : null)}
          />
        }
      >
        <Link
          to="/"
          className={cx(classes.mainLink, darkTheme ? 'dark' : null)}
        >
          Дашборд
        </Link>
        <Link
          to={linksData.link}
          className={cx(classes.mainLink, darkTheme ? 'dark' : null)}
        >
          {linksData.parentPageName}
        </Link>
        <Link
          to={linksData.link}
          className={cx(classes.mainLink, darkTheme ? 'dark' : null)}
        >
          {linksData.pageName}
        </Link>
        {linksData.name && (
          <MuiLink
            underline="none"
            color="inherit"
            className={cx(classes.mainLink, darkTheme ? 'dark' : null)}
          >
            {linksData.name}
          </MuiLink>
        )}
      </Breadcrumbs>
    </Box>
  );
};

export default CollapsedBreadcrumbs;
